"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestErrorHandler = void 0;
var tslib_1 = require("tslib");
var models_1 = require("../models");
var default_expired_token_error_handler_1 = require("./default-expired-token.error-handler");
var service_1 = require("../service");
var refresh_token_response_guard_1 = require("./response-guards/refresh-token-response-guard");
var pending_requests_registry_1 = require("../pending-requests-registry");
var getExtendedResponse = function (refreshTokenResponse, response) {
    var events = refreshTokenResponse.events;
    return events ? tslib_1.__assign({ events: events }, response) : response;
};
var handleErrorResponse = function (request, errorResponse, callback
// eslint-disable-next-line max-params
) {
    var _a;
    var handleRefreshTokenError = function (req) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var refreshToken;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, service_1.authSuiteDataLocalStorageService.getDeviceRefreshToken()];
                case 1:
                    refreshToken = _a.sent();
                    return [2 /*return*/, default_expired_token_error_handler_1.defaultExpiredTokenErrorHandler
                            .handleExpiration(req)
                            .then((0, refresh_token_response_guard_1.refreshTokenResponseGuard)(refreshToken))
                            .then(function (refreshTokenResponse) {
                            return callback(req)
                                .then(function (response) { return getExtendedResponse(refreshTokenResponse, response); })
                                .catch(function (error) { return Promise.reject(getExtendedResponse(refreshTokenResponse, error)); });
                        })];
            }
        });
    }); };
    var handleInvalidUserDataResponse = function (error) {
        pending_requests_registry_1.authSuitePendingRequestRegistry.clearRegisteredRequest({ requestKey: pending_requests_registry_1.PendingRequestKey.REFRESH_TOKEN });
        service_1.authSuiteDataLocalStorageService.removeAccessTokens();
        return Promise.reject(error);
    };
    var errorHandlers = (_a = {},
        _a[models_1.ErrorCode.ExpiredToken] = handleRefreshTokenError,
        _a[models_1.ErrorCode.NeedsRefresh] = handleRefreshTokenError,
        _a[models_1.ErrorCode.InvalidUserDataResponse] = handleInvalidUserDataResponse,
        _a);
    var resp = errorResponse;
    return errorHandlers[resp.errorCode] ? errorHandlers[resp.errorCode](request) : Promise.reject(errorResponse);
};
exports.requestErrorHandler = {
    handleErrorResponse: handleErrorResponse,
};
